import type { ReactNode } from 'react';
import { Dropdown } from 'react-bootstrap';

interface WarrantyTableActionItemProps {
    icon: ReactNode;
    title: string;
    description: string;
    onClick: () => void;
    danger?: boolean;
    disabled?: boolean;
}

const WarrantyTableActionItem = ({ icon, title, description, onClick, danger = false, disabled = false }: WarrantyTableActionItemProps) => (
    <Dropdown.Item
        as="button"
        disabled={disabled}
        className={danger ? 'text-danger' : undefined}
        onClick={(event) => {
            onClick();
            event.currentTarget.blur();
        }}
    >
        <div className="d-flex align-items-start w-100 text-start">
            <span
                className={`d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon${danger ? ' text-danger' : ''}`}
            >
                {icon}
            </span>
            <div className="flex-grow-1 min-w-0">
                <div className={`fw-medium ${danger ? 'text-danger' : ''}`}>{title}</div>
                <small className="text-muted warehouse-team-menu-hint">{description}</small>
            </div>
        </div>
    </Dropdown.Item>
);

export default WarrantyTableActionItem;
